import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { NumberConstants, Notifications } from '../../../../configs/app.config';

@Component({
  selector: 'sra-text-area',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.scss'],
})
export class TextAreaComponent implements AfterViewInit, OnChanges {
  @Input() id: string | undefined = undefined;
  @Input() placeholder: string | undefined = undefined;
  @Input() disabled = false;
  @Input() customClass: string | undefined = undefined;
  @Input() value!: string;
  @Input() height?: string = '42px';
  @Input() maxLength?: number;
  @Input() showCharCount = false;
  @Output() textChanged = new EventEmitter<string>();
  @Output() validationStatus = new EventEmitter<boolean>();

  @ViewChild('textareaRef') textarea!: ElementRef<HTMLTextAreaElement>;

  numberConstants = NumberConstants;
  currentLength = 0;

  ngAfterViewInit() {
    this.adjustHeight(); // Adjust height initially if there's any pre-filled content
    this.currentLength = this.value?.length ?? 0;
    this.validationStatus.emit(!this.isAtLimit);
  }

  onInput(event: Event) {
    const textArea = event.target as HTMLTextAreaElement;
    this.currentLength = textArea.value.length;
    this.textChanged.emit(textArea.value);
    this.validationStatus.emit(!this.isAtLimit);
  }

  get maxLengthValue(): number {
    return this.maxLength ?? this.numberConstants.MAX_TEXTFIELD_LENGTH;
  }

  get isAtLimit(): boolean {
    return this.currentLength > this.maxLengthValue;
  }

  get validationMessage(): string {
    return Notifications.CHARACTER_LIMIT_EXCEEDED.replace('{0}', this.maxLengthValue.toString());
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['value'] && changes['value'].currentValue !== undefined) {
      this.currentLength = changes['value'].currentValue?.length ?? 0;
      this.validationStatus.emit(!this.isAtLimit);
    }
  }

  adjustHeight() {
    const textareaEl = this.textarea.nativeElement;
    textareaEl.style.height = `${this.height}`; // Reset the height
    textareaEl.style.height = `${textareaEl.scrollHeight}px`; // Set height to scrollHeight
  }
}
